import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const AnalyticsCacheContext = createContext(null);

export const AnalyticsCacheProvider = ({ children }) => {
  const [cache, setCache] = useState(() => window.__analyticsCache || null);
  const cacheRef = useRef(cache);

  const updateCache = useCallback((data) => {
    cacheRef.current = data;
    setCache(data);
    // Keep window.__analyticsCache in sync for backward compatibility
    window.__analyticsCache = data;
  }, []);

  const getCache = useCallback(() => {
    return cacheRef.current;
  }, []);

  return (
    <AnalyticsCacheContext.Provider value={{ cache, updateCache, getCache }}>
      {children}
    </AnalyticsCacheContext.Provider>
  );
};

export const useAnalyticsCache = () => {
  const ctx = useContext(AnalyticsCacheContext);
  if (!ctx) throw new Error('useAnalyticsCache must be used within AnalyticsCacheProvider');
  return ctx;
};

export default AnalyticsCacheContext;
